import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import { connect } from "react-redux";
import GetLocation from "./GetLocation";
import { MdLocationOn, MdCheck } from "react-icons/md";
import { locationDuck } from "../../ducks/location";
import { gaTracker } from "../../util/ga-analytics";
import { mobileAppUtil, locationUtil } from '../../util';
var locationOperations = locationDuck.operations;

var locationInfoGa = function locationInfoGa(htmlid, label) {
  var data = {
    gtm: {
      uniqueEventId: "44",
      elementId: htmlid,
      elementText: label
    },
    event: "gtm.click"
  };
  gaTracker(data);
};

var LocationInfo = /*#__PURE__*/function (_Component) {
  _inherits(LocationInfo, _Component);

  var _super = _createSuper(LocationInfo);

  function LocationInfo(props) {
    var _props$location;

    var _this;

    _classCallCheck(this, LocationInfo);

    _this = _super.call(this, props);
    _this.innerRef = void 0;
    _this.state = {
      isLoading: props.isLoading || false,
      isError: props.isError || false,
      err: props.err,
      location: props.location || {},
      located: ((_props$location = props.location) === null || _props$location === void 0 ? void 0 : _props$location.located) || false
    };
    _this.getInnerRef = _this.getInnerRef.bind(_assertThisInitialized(_this));
    _this.handleSuccess = _this.handleSuccess.bind(_assertThisInitialized(_this));
    _this.handleError = _this.handleError.bind(_assertThisInitialized(_this));

    if (mobileAppUtil.isMobileApp()) {
      var _this$props, _this$props$location;

      if (!((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$location = _this$props.location) === null || _this$props$location === void 0 ? void 0 : _this$props$location.located)) {
        _this.props.mobileAutoSelectLocation();

        _this.props.setUserModified(false);

        _this.props.setLocated();
      }
    }

    return _this;
  }

  _createClass(LocationInfo, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.isLoading !== this.props.isLoading) {
        this.setState({
          isLoading: newProps.isLoading
        });
      }

      if (newProps.isError !== this.props.isError) {
        this.setState({
          isError: newProps.isError,
          err: newProps.err
        });
      }

      if (newProps.location !== this.props.location) {
        this.setState({
          location: newProps.location
        });

        if (!newProps.location.located) {
          var isFirefoxAgent = navigator.userAgent.indexOf("Firefox") > -1;

          if (!isFirefoxAgent) {
            if (mobileAppUtil.isMobileApp()) {} else {
              this.innerRef.getLocation();
              this.props.setLocated();
            }
          }
        }
      }

      if (newProps.results !== this.props.results) {
        this.setState({
          results: newProps.location
        });
      }
    }
  }, {
    key: "getInnerRef",
    value: function getInnerRef(ref) {
      this.innerRef = ref;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(position) {
      if (typeof position.coords === "object") {
        this.props.changeLatLon(position.coords);
        this.props.getLocationByGps();
      } else {
        console.log("Error: ", position.coords);
      }
    }
  }, {
    key: "handleError",
    value: function handleError() {
      console.log('Location cancelled');
      this.props.setLocated();
    }
  }, {
    key: "changeLocationHandler",
    value: function changeLocationHandler(e) {
      if (typeof this.props.changeLocationHandler === "function") {
        return this.props.changeLocationHandler(e);
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$location2,
          _this$props$location3,
          _this$props$location4,
          _this$props$overrideS,
          _this$props$location5,
          _this$props$location6,
          _this2 = this,
          _location$_distanceuo;

      var location = typeof this.props.overrideStore !== "undefined" ? this.props.overrideStore : (_this$props$location2 = this.props.location) === null || _this$props$location2 === void 0 ? void 0 : _this$props$location2.location;
      var isTheSelectedStore = ((_this$props$location3 = this.props.location) === null || _this$props$location3 === void 0 ? void 0 : (_this$props$location4 = _this$props$location3.location) === null || _this$props$location4 === void 0 ? void 0 : _this$props$location4.storeuid) != null && ((_this$props$overrideS = this.props.overrideStore) === null || _this$props$overrideS === void 0 ? void 0 : _this$props$overrideS.storeuid) == ((_this$props$location5 = this.props.location) === null || _this$props$location5 === void 0 ? void 0 : (_this$props$location6 = _this$props$location5.location) === null || _this$props$location6 === void 0 ? void 0 : _this$props$location6.storeuid);
      var label = typeof this.props.overrideStore !== "undefined" ? isTheSelectedStore ? "Confirm" : "Select" : "Change";
      var getInnerRef = this.getInnerRef,
          getLocation = this.getLocation;
      var waitTimeText = locationUtil.getWaitListText(location);
      return /*#__PURE__*/React.createElement("div", {
        className: "\n      d-flex justify-content-start align-items-center\n      ".concat(this.props.className !== "undefined" ? this.props.className : "", "\n      ")
      }, !this.props.located && /*#__PURE__*/React.createElement(GetLocation, {
        ref: getInnerRef,
        onSuccess: this.handleSuccess,
        getLocationByGps: this.props.getLocationByGps,
        onError: this.handleError
      }), isTheSelectedStore ? /*#__PURE__*/React.createElement(MdCheck, {
        style: {
          color: "green",
          height: "2em",
          width: "2em"
        }
      }, " ") : /*#__PURE__*/React.createElement(MdLocationOn, {
        className: "cb-location-banner__icon cb-color-blue-500"
      }), /*#__PURE__*/React.createElement("div", {
        className: "\n        cb-location-banner__location\n        ".concat(this.props.isLoading ? "is-fetching" : "", "\n        ").concat(this.props.isError ? "is-error" : "", "\n        ")
      }, !this.props.isLoading ? /*#__PURE__*/React.createElement("div", {
        className: "cb-location-banner__copy"
      }, this.props.isError || location === null ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
        href: "#",
        id: "pickLocation",
        onClick: function onClick(e) {
          locationInfoGa("pickLocation", "Pick your location");

          _this2.props.changeLocationHandler(e);
        }
      }, "Pick your location")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, this.props.simple ? /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "cb-color-brown-400 cb-type--underline",
        onClick: function onClick(e) {
          _this2.changeLocationHandler(e);
        }
      }, (location === null || location === void 0 ? void 0 : location.alternate_name) || (location === null || location === void 0 ? void 0 : location.alternateName))) : /*#__PURE__*/React.createElement("strong", null, (location === null || location === void 0 ? void 0 : location.alternate_name) || (location === null || location === void 0 ? void 0 : location.alternateName), !Boolean(location === null || location === void 0 ? void 0 : location.temporarilyclosed) && /*#__PURE__*/React.createElement("span", {
        className: "cb-location-banner__time"
      }, waitTimeText)), /*#__PURE__*/React.createElement("br", null), !this.props.simple ? /*#__PURE__*/React.createElement("p", null, location === null || location === void 0 ? void 0 : location.address1, ",\xA0", location === null || location === void 0 ? void 0 : location.city, ",\xA0", /*#__PURE__*/React.createElement("span", null, location === null || location === void 0 ? void 0 : location.state, " ", (location === null || location === void 0 ? void 0 : location._distanceuom) && /*#__PURE__*/React.createElement(React.Fragment, null, "-\xA0", location === null || location === void 0 ? void 0 : location._distance, "\xA0", location === null || location === void 0 ? void 0 : (_location$_distanceuo = location._distanceuom) === null || _location$_distanceuo === void 0 ? void 0 : _location$_distanceuo.substring(0, 2)), "\xA0", isTheSelectedStore ? /*#__PURE__*/React.createElement("a", {
        href: "#",
        "aria-readonly": true,
        onClick: function onClick(e) {
          _this2.changeLocationHandler(e);
        },
        id: "locationlabel-".concat(location === null || location === void 0 ? void 0 : location.alternate_name)
      }, "(", label, ")") : /*#__PURE__*/React.createElement("a", {
        href: "#",
        id: "locationlabel-".concat(location === null || location === void 0 ? void 0 : location.alternate_name),
        onClick: function onClick(e) {
          _this2.changeLocationHandler(e);
        }
      }, "(", label, ")"))) : null, !this.props.simple && Boolean(location === null || location === void 0 ? void 0 : location.temporarilyclosed) ? /*#__PURE__*/React.createElement("p", {
        className: "cb-location-banner__closed"
      }, "This location is temporarily closed") : null, !this.props.simple && Boolean(location === null || location === void 0 ? void 0 : location.orderOnline) ? /*#__PURE__*/React.createElement("p", {
        className: "cb-location-banner__order-closed"
      }, "Online ordering is currently unavailable. Please call the store to place your order") : null))) : /*#__PURE__*/React.createElement("p", null, "Finding the closest Cracker Barrel...")));
    }
  }]);

  return LocationInfo;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  var _state$location, _state$location$locat;

  return _objectSpread(_objectSpread({}, state), {}, {
    //unwraps - returns an obj to return state
    located: (_state$location = state.location) === null || _state$location === void 0 ? void 0 : _state$location.located,
    orderOnline: (_state$location$locat = state.location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.OnlineOrdering
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeLatLon: function changeLatLon(text) {
      return dispatch(locationOperations.changeLatLon(text));
    },
    getLocationByGps: function getLocationByGps() {
      return dispatch(locationOperations.getLocationByGps());
    },
    mobileAutoSelectLocation: function mobileAutoSelectLocation() {
      return dispatch(locationOperations.mobileAutoSelectLocation());
    },
    setUserModified: function setUserModified(userModified) {
      return dispatch(locationOperations.setUserModified(userModified));
    },
    setLocated: function setLocated() {
      return dispatch(locationOperations.setLocated());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationInfo);